import { ICustomEmoji, ICustomEmojiSet } from './client';
import { CustomEmojiServer, CustomEmojiSetServer } from './server';

export const normalizeCustomEmoji = (raw: CustomEmojiServer): ICustomEmoji => {
  return {
    customEmojiId: raw.custom_emoji_id,
    fallbackEmoji: raw.fallback_emoji,
    previewUrl: raw.preview_url
  };
};

export const normalizeCustomEmojiSet = (
  raw: CustomEmojiSetServer
): ICustomEmojiSet => {
  return {
    setName: raw.set_name,
    title: raw.title,
    dateUpdated: new Date(raw.date_updated),
    emojis: raw.emojis.map(normalizeCustomEmoji)
  };
};
